module.exports = __webpack_public_path__ + "static/media/am-screens-2.84d25982.png";